import React, { Component } from "react";
import { connect } from "react-redux";
import { store } from "../..";
import EatWithMeActions from "../../actions/EatWithMeActions";

class DayNight extends Component {

  render() {
    var clazz = this.props.on ? "icon-moon-inv hide-print" : "icon-moon hide-print";
    return (
      <div onClick={this.onClick} className={clazz} style={{ paddingLeft: "4px", paddingRight: "4px", fontSize: "24px", color: "rgb(131, 123, 108)" }}>
      </div>
    );
  }

  onClick = () => {
    store.dispatch(EatWithMeActions.daynight(!this.props.on));
  }
}

const mapStateToProps = (props, state) => {
  return {
    on: props.rootReducer.daynight,
  };
};

export default connect(mapStateToProps)(DayNight);
